import {
  createRouter,
  createWebHistory,
  NavigationGuardNext,
  RouteLocationNormalized,
} from "vue-router";
import { authGuard, onboardingGuard, roleGuard } from "./guards";
import { authRoutes } from "./routes/auth";
import { protectedRoutes } from "./routes/protected";
import { publicRoutes } from "./routes/public";

export const routes = [...publicRoutes, ...authRoutes, ...protectedRoutes];

export const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(
  authGuard as (
    to: RouteLocationNormalized,
    from: RouteLocationNormalized,
    next: NavigationGuardNext,
  ) => void,
);

router.beforeEach(
  onboardingGuard as (
    to: RouteLocationNormalized,
    from: RouteLocationNormalized,
    next: NavigationGuardNext,
  ) => void,
);

router.beforeEach(
  roleGuard as (
    to: RouteLocationNormalized,
    from: RouteLocationNormalized,
    next: NavigationGuardNext,
  ) => void,
);

export default router;
